import wwdevCheckout from "@wwdev/webshop/checkout";

wwdevCheckout._toggleShipmentAddress = function (e) {
	let value = $('select[name="deliver_address_id"]').val();
	console.log(value);
	let $shipmentScope = this.$checkout.find('[data-checkout-shipment="scope"]');
	if(value == 0) {
		this.$checkout.find('[data-checkout-shipment="show-if-shipment"]').show();
		this.$checkout.find('[data-checkout-shipment="show-if-same"]').hide();
		$shipmentScope.slideDown();
	} else {
		this.$checkout.find('[data-checkout-shipment="show-if-shipment"]').show();
		this.$checkout.find('[data-checkout-shipment="show-if-same"]').hide();
		$shipmentScope.slideUp();
	}
}

wwdevCheckout.init();

class Checkout {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-checkout-shipment="scope"]',
			shippingOption: '[data-action="select_shipping"]',
			delivery: '[data-checkout="delivery"]',
		}, config)

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
		this.hideDeliveryIfNeeded();
	}

	addEventListeners() {
		$(document).off('.delivery')
			.on('change.delivery', this.config.shippingOption, this.hideDeliveryIfNeeded.bind(this))
			.on('change.delivery', 'select[name="deliver_address_id"]', this.changeDeliverAddress.bind(this))
			.on('change.delivery', ':input', this.updateAddressInSummary.bind(this));
	}

	changeDeliverAddress(event) {
		wwdevCheckout._toggleShipmentAddress();

		let $deliverAddress = this.$scope;
		let $option = $('select[name="deliver_address_id"]').find('option:selected');
		let addressData = $option.data('addressInfo');

		$deliverAddress.find('input[name="shipping_street"]').val(addressData.street);
		$deliverAddress.find('input[name="shipping_street_number"]').val(addressData.street_number);
		$deliverAddress.find('input[name="shipping_street_number_extra"]').val(addressData.street_number_extra);
		$deliverAddress.find('input[name="shipping_company"]').val(addressData.company)
		$deliverAddress.find('input[name="shipping_zipcode"]').val(addressData.zipcode);
		$deliverAddress.find('input[name="shipping_town"]').val(addressData.town);
		$deliverAddress.find('input[name="shipping_initials"]').val(addressData.initials);
		$deliverAddress.find('input[name="shipping_lastname"]').val(addressData.lastname);
		$deliverAddress.find('input[name="shipping_middlename"]').val(addressData.middlename);
		$deliverAddress.find('input[name="shipping_phone"]').val(addressData.phone);
		$deliverAddress.find('input[name="shipping_phone_backup"]').val(addressData.phone_backup);
		$deliverAddress.find('input[name="shipping_mailbox"]').val(addressData.mailbox);
		$deliverAddress.find('select[name="shipping_country"]').val(addressData.country_id).trigger('change');
	}

	updateAddressInSummary(event) {
		let $source = $(event.currentTarget).closest(this.config.scope);
		let $target = $('.user-summary-delivery');
		console.log($source);
		if ($('select[name="deliver_address_id"] option:checked').val == '1') {
			this.updateAddressByInvoiceAddress();
		} else {
			$target.find('[data-name="shipping_company"]').html($source.find('input[name="shipping_company"]').val());
			let nameParts = [
				$source.find('input[name="shipping_initials"]:first').val(),
				$source.find('input[name="shipping_middlename"]:first').val(),
				$source.find('input[name="shipping_lastname"]:first').val()
			];
			let name = nameParts.filter((val) => val != '').join(' ');
			$target.find('[data-ww-bind="shipping_company"]').html($source.find('input[name="shipping_company"]').val());
			$target.find('[data-ww-bind="shipping_name"]').html(name);
			$target.find('[data-ww-bind="shipping_street"]').html($source.find('input[name="shipping_street"]').val());
			$target.find('[data-ww-bind="shipping_street_number"]').html($source.find('input[name="shipping_street_number"]').val());
			$target.find('[data-ww-bind="shipping_street_number_extra"]').html($source.find('input[name="shipping_street_number_extra"]').val());
			$target.find('[data-ww-bind="shipping_zipcode"]').html($source.find('input[name="shipping_zipcode"]').val());
			$target.find('[data-ww-bind="shipping_town"]').html($source.find('input[name="shipping_town"]').val());
			$target.find('[data-ww-bind="shipping_country"]').html($source.find('select[name="shipping_country"] option:selected').html());
		}
	}

	updateAddressByInvoiceAddress() {
		let $source = $('.address-invoice');
		let $target = $('.user-summary-delivery');
		$target.find('[data-name="shipping_company"]').html($source.find('input[name="company"]').val());
		$target.find('[data-name="shipping_street"]').html($source.find('input[name="street"]').val());
		$target.find('[data-name="shipping_street_number"]').html($source.find('input[name="street_number"]').val());
		$target.find('[data-name="shipping_street_number_extra"]').html($source.find('input[name="street_number_extra"]').val());
	}

	hideDeliveryIfNeeded() {

		let $delivery = $(this.config.delivery);
		let $option = $(`${this.config.shippingOption}:checked`);
		let $optionAddress = $('select[name="deliver_address_id"]').find('option:selected')
		if ($option.length > 0 && $option.val() === 'bezorgen') {
			wwdevCheckout._toggleShipmentAddress();
			this.changeDeliverAddress();
			$delivery.removeClass('hidden');
			$('#shipping-address-fieldset').attr('disabled', false);
			$('[data-shipping-option-extra]').removeClass('d-none');
			if($optionAddress.val() == 0 ){
				$('.address-shipping').removeClass('hidden');
			}
			return;
		}
		$('#shipping-address-fieldset').attr('disabled', true);
		$('[data-shipping-option-extra]').addClass('d-none')
		$('.address-shipping').addClass('hidden');
		$delivery.addClass('hidden');
	}
}

export default new Checkout();